"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.regexp.to-string.js");
var _fetch = require("../utils/fetch");
var _util = require("./util");
var _zzUtils = require("@zz-common/zz-utils");
var UploadImg = /*#__PURE__*/function () {
  function UploadImg(options, capture) {
    this.wechatConfigErrTimes = 0;
    this.wechatConfigErrMax = 3;
    this._chooseFinish = false;
    this._uploadFinish = false;
    this._ajaxFinish = false;
    this.pCtx = null;
    this.options = {
      count: 1,
      // 默认1
      sizeType: ['compressed'],
      // 可以指定是原图还是压缩图，默认压缩
      sourceType: ['album'],
      // 可以指定来源是相册还是相机，默认相册
      showLoading: 1,
      // 默认为1，显示进度提示
      wxPublicId: '26',
      onChooseSuccess: function onChooseSuccess(res) {}
    };
    this.mergeOptions(options, capture);
  }
  var _proto = UploadImg.prototype;
  _proto.mergeOptions = function mergeOptions(options, capture) {
    Object.assign(this.options, {
      sourceType: capture ? ['camera'] : ['album']
    }, options);
  };
  _proto.previewImgs = function previewImgs(imgs) {
    if (!imgs || !imgs.length) return;
    wx.previewImage({
      /* eslint-disable-line no-undef */
      current: imgs[0],
      // 当前显示图片的http链接
      urls: imgs // 需要预览的图片http链接列表
    });
  };
  _proto.chooseImages = function chooseImages(options, capture, ctx) {
    var _this = this;
    // 支持水印, 因为 actionOptions 引用变化 因此需要传父级对象引用
    this.pCtx = ctx;
    this.mergeOptions(options, capture);
    return new Promise(function (resolve, reject) {
      wx.chooseImage({
        /* eslint-disable-line no-undef */
        count: _this.options.count,
        sizeType: _this.options.sizeType,
        sourceType: _this.options.sourceType,
        fail: function fail(e) {
          return reject(e);
        },
        success: function () {
          var _success = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(res) {
            var localIds, uploadImages, i, img;
            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                  localIds = res.localIds;
                  uploadImages = [];
                  if (!(!localIds || !localIds.length)) {
                    _context.next = 5;
                    break;
                  }
                  window.eventHub.$emit('toast', '请选择需要上传的图片');
                  return _context.abrupt("return");
                case 5:
                  if (_this.options.onChooseSuccess) _this.options.onChooseSuccess(res);
                  if (!_this.options.concurrency) {
                    _context.next = 12;
                    break;
                  }
                  _context.next = 9;
                  return Promise.all(localIds.map(function (id) {
                    return _this._uploadImage(id);
                  }));
                case 9:
                  uploadImages = _context.sent;
                  _context.next = 21;
                  break;
                case 12:
                  i = 0;
                case 13:
                  if (!(i < localIds.length)) {
                    _context.next = 21;
                    break;
                  }
                  _context.next = 16;
                  return _this._uploadImage(localIds[i]);
                case 16:
                  img = _context.sent;
                  /* eslint-disable-line no-await-in-loop */
                  uploadImages.push(img);
                case 18:
                  i++;
                  _context.next = 13;
                  break;
                case 21:
                  console.log('uploadImages', uploadImages);
                  resolve(uploadImages);
                case 23:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function success(_x) {
            return _success.apply(this, arguments);
          }
          return success;
        }()
      });
    });
  };
  _proto._uploadImage = /*#__PURE__*/function () {
    var _uploadImage2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(localId) {
      var _this2 = this;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function (resolve) {
              // 兼容企业微信
              if (_util.isWxWork) {
                _this2._getUploadImageFileInWork(localId).then(resolve).catch(function () {
                  return resolve(undefined);
                });
                return;
              }
              console.log('wx.uploadImage');
              wx.uploadImage({
                /* eslint-disable-line no-undef */
                // 需要上传的图片的本地ID，由chooseImage接口获得，toString()以避免奇怪的问题
                localId: localId.toString(),
                isShowProgressTips: _this2.options.showLoading,
                success: function () {
                  var _success2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(res) {
                    var serverId, img;
                    return _regenerator.default.wrap(function _callee2$(_context2) {
                      while (1) switch (_context2.prev = _context2.next) {
                        case 0:
                          serverId = res.serverId; // 返回图片的服务器端ID
                          _context2.next = 3;
                          return _this2._getUploadImageFileName(serverId);
                        case 3:
                          img = _context2.sent;
                          resolve(img);
                        case 5:
                        case "end":
                          return _context2.stop();
                      }
                    }, _callee2);
                  }));
                  function success(_x3) {
                    return _success2.apply(this, arguments);
                  }
                  return success;
                }(),
                fail: function fail() {
                  resolve(undefined);
                }
              });
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function _uploadImage(_x2) {
      return _uploadImage2.apply(this, arguments);
    }
    return _uploadImage;
  }() // 兼容企业微信
  ;
  _proto._getUploadImageFileInWork =
  /*#__PURE__*/
  function () {
    var _getUploadImageFileInWork2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(localId) {
      var data, imgUrl;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return this._getUploadImageFileDataInWork(localId);
          case 3:
            data = _context4.sent;
            _context4.next = 6;
            return this._getImageUrlByData(data);
          case 6:
            imgUrl = _context4.sent;
            console.log('_getUploadImageFileInWork', imgUrl);
            return _context4.abrupt("return", imgUrl);
          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", undefined);
          case 14:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this, [[0, 11]]);
    }));
    function _getUploadImageFileInWork(_x4) {
      return _getUploadImageFileInWork2.apply(this, arguments);
    }
    return _getUploadImageFileInWork;
  }();
  _proto._getUploadImageFileDataInWork = function _getUploadImageFileDataInWork(localId) {
    return new Promise(function (resolve) {
      // iOS应当使用 getLocalImgData 获取图片base64数据
      // 在img标签内使用 wx.chooseImage 的 localid 显示可能会不成功
      wx.getLocalImgData({
        localId: localId,
        // 图片的localID
        success: function success(res) {
          var localData = res.localData; // localData是图片的base64数据，可以用img标签显示
          resolve(localData);
        }
      });
    });
  };
  _proto._getImageUrlByData = function _getImageUrlByData(data) {
    var _this3 = this;
    return new Promise(function (resolve) {
      var _this3$pCtx, _this3$pCtx$actionOpt;
      console.log('upload', _this3.pCtx.actionOptions);
      _zzUtils.upload.uploadPic({
        file: data,
        options: {
          params: (_this3$pCtx = _this3.pCtx) === null || _this3$pCtx === void 0 ? void 0 : (_this3$pCtx$actionOpt = _this3$pCtx.actionOptions) === null || _this3$pCtx$actionOpt === void 0 ? void 0 : _this3$pCtx$actionOpt.data
        },
        onSuccess: function onSuccess(_, data) {
          resolve(data.respData);
        },
        onError: function onError() {
          resolve(undefined);
        }
      });
    });
  };
  _proto._getUploadImageFileName = /*#__PURE__*/function () {
    var _getUploadImageFileName2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(mediaId) {
      var source, res, code, data;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            source = (0, _util.getQueryString)('wxPublicId') || this.options.wxPublicId || '26';
            _context5.next = 3;
            return (0, _fetch.fetch)({
              url: "/zzopen/wxcommon/getUploadImageFileName?mediaId=" + mediaId + "&source=" + source
            });
          case 3:
            res = _context5.sent;
            code = +res.respCode;
            data = res.respData;
            if (!(code === 0)) {
              _context5.next = 8;
              break;
            }
            return _context5.abrupt("return", data.result);
          case 8:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this);
    }));
    function _getUploadImageFileName(_x5) {
      return _getUploadImageFileName2.apply(this, arguments);
    }
    return _getUploadImageFileName;
  }();
  return UploadImg;
}();
var _default = UploadImg;
exports.default = _default;